export class UserRightsFunctionToUserPrivilegesDTO {

  //region FIELDS
  userRightsFunctionId: string;
  userPrivilegeIds: string[] = [];
  //endregion

}
